const iconSets = {
  icon: (icon) => `icon-${icon}`,
  glyphicon: (icon) => `glyphicon glyphicon-${icon}`
};

export default iconSets;



// WEBPACK FOOTER //
// ./src/constants/icon-sets.js